export const lenisStore = { current: null };

export const scrollToId = (id, immediate = false) => {
  const target = id === "top" ? 0 : document.getElementById(id);
  if (target === null) return;
  if (lenisStore.current) lenisStore.current.scrollTo(target, { offset: id === "top" ? 0 : -80, immediate });
  else if (target === 0) window.scrollTo(0, 0);
  else target.scrollIntoView({ behavior: immediate ? "auto" : "smooth" });
};
